import React from 'react';

import CommonImage from '@/components/CommonImage';

const TaskFilterListTable = ({ categoryName, items }) => {
	return (
		<div className="journey-configuration-container py-2">
			<div className="journey-configuration-table create-list-table mt-3">
				<p className="semibold-14 mb-12">
					{categoryName} ({items.length})
				</p>
				<table className="table height-sm with-border">
					<thead>
						<tr>
							<th>SL({items.length})</th>
							<th>List name</th>
							<th>Description</th>
							<th>Lead time</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{items.length > 0 ? (
							items.map((item, index) => (
								<tr
									key={item.id}
									onClick={(e) => {
										// Don't navigate if clicking on action column
										if (e.target.closest('.action-column')) {
											return;
										}
										window.open(
											`/my-dashboard?tab=MY_DASHBOARD_STYLES&filterId=${item.id}&filterTitle=${encodeURIComponent(item.title || '')}`,
											'_blank'
										);
									}}
									style={{ cursor: 'pointer' }}
								>
									<td className="sl-column">
										<p>{index + 1}</p>
									</td>
									<td className="journey-start-column">
										<p>{item.title}</p>
									</td>
									<td className="journey-end-column">
										<p>{item.details || '--'}</p>
									</td>
									<td className="journey-end-column">
										<p>{item.leadTime || '--'}</p>
									</td>
									<td className="action-column">
										<div className="option">
											<div className="dropdown">
												<button
													aria-expanded="false"
													className="btn btn-default dropdown-toggle"
													data-toggle="dropdown"
													id={`menu-${item.id}`}
													type="button"
												>
													<CommonImage src="/icons/more_icon.svg" alt="more_icon" />
												</button>
												<ul
													aria-labelledby={`menu-${item.id}`}
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													x-placement="bottom-end"
												>
													<li
														className="px-4 pb-3 pt-3"
														role="presentation"
														onClick={() => {
															window.open(
																`/configuration/task?tab=CREATE_LIST&editFilterId=${item.id}`,
																'_blank'
															);
														}}
													>
														<span
															className="font-weight-normal  text-black"
															role="menuitem"
															tabIndex={-1}
														>
															Edit
														</span>
													</li>
												</ul>
											</div>
										</div>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="5" className="text-center">
									No items found
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default TaskFilterListTable;
